import React from 'react';

export default function Configuracoes() {
  return (
    <div className="space-y-6" data-testid="configuracoes-page">
      <div className="bg-white rounded-lg border border-slate-200 p-6">
        <h2 className="text-base font-semibold text-slate-900 mb-4">Meus Serviços / Produtos</h2>
        <div className="bg-slate-50 border-2 border-dashed border-slate-200 rounded-lg p-10 text-center">
          <svg className="w-12 h-12 mx-auto text-slate-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="1.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 7.5-.625 12h.75l-.625-4.5m19.5 0h-1.5m1.5 0v10.875c0 .621-.504 1.125-1.125 1.125h-14.25a1.125 1.125 0 0 1-1.125-1.125V7.5M9 7.5v-1.5A2.25 2.25 0 0 1 11.25 3.75h1.5A2.25 2.25 0 0 1 15 6v1.5m-6 0h6" />
          </svg>
          <p className="text-sm font-medium text-slate-700 mb-1">Multi-produto (em breve)</p>
          <p className="text-xs text-slate-500 max-w-md mx-auto">
            Aqui você poderá cadastrar novos serviços/produtos que vende, além do AgroLink CRM.
            Cada serviço poderá ter seu próprio plano, valor, ciclo de cobrança e configurações.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 p-6">
        <h2 className="text-base font-semibold text-slate-900 mb-2">Sobre o painel</h2>
        <div className="text-xs text-slate-600 space-y-1">
          <p><span className="font-medium">Versão:</span> Admin Panel v2.0</p>
          <p><span className="font-medium">Empresa:</span> AgroLink CRM</p>
          <p><span className="font-medium">Serviços gerenciados:</span> 1 (AgroLink CRM)</p>
        </div>
      </div>
    </div>
  );
}
